export default class TypeFilter {
  TypeFilter() {
    return {
      'policy': 'Policy',
      'poster': 'Poster',
    };
  }
}
